import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Typography,
} from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import TableItem from './TableItem';
import type { AveragrCycleTimeType } from 'types/production.types';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  enableDarkTheme: boolean;
  data: AveragrCycleTimeType[];
}

const TableList = ({ enableDarkTheme, data }: Props) => {
  const { t } = useTranslation();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell sx={{ borderBottom: '1px solid #2F445F' }}>
            <Typography color={palette.textSecondary}>
              {t('state_word')}
            </Typography>
          </TableCell>
          <TableCell align="right" sx={{ borderBottom: '1px solid #2F445F' }}>
            <Typography color={palette.textSecondary}>
              {t('time_word')}
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((state, index) => (
          <TableItem item={state} key={index} />
        ))}
      </TableBody>
    </Table>
  );
};

export default TableList;
